import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';
import StatusIcon = RsnDialog.StatusIcon;

export function WalletsCreatedDialog({onClose}: {onClose: () => void}) {
    return (
        <RsnDialog.Window onExitEnd={onClose}>
            <RsnDialog.CenteredHeader icon={{element: <StatusIcon status={'check'} />}}>
                Virtual wallets have been created
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>Your account is ready to use.</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent={'secondary'}>
                    Continue
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
